import React from "react"
import { Switch, Route } from "react-router-dom"
import BaseLayout from "src/layouts/Base"
import Events from "src/containers/Events"
import withRouteValidation from "src/hocs/withRouteValidation"
import {
  EVENTS_URL,
  EVENTS_ID_URL,
  DEFAULT_UUID_VALIDATION_CONFIG,
} from "src/constants/routeNames"

export default (
  <Route path={EVENTS_URL}>
    <Switch>
      <Route path={EVENTS_URL}>
        <BaseLayout title="События">
          <Switch>
            <Route path={EVENTS_URL} exact component={Events} />
            <Route
              path={EVENTS_ID_URL}
              component={withRouteValidation({
                routeValidationConfig: DEFAULT_UUID_VALIDATION_CONFIG,
              })(Events)}
            />
          </Switch>
        </BaseLayout>
      </Route>
    </Switch>
  </Route>
)
